'use client'

import { useSearchParams, usePathname } from 'next/navigation'
import { useEffect } from 'react'

export default function WidgetModeHandler() {
  const searchParams = useSearchParams()
  const pathname = usePathname()
  const isWidget = pathname === '/' && searchParams.get('source') === '1'

  useEffect(() => {
    // Always clean up first
    document.body.removeAttribute('data-widget-mode')
    document.body.classList.remove('widget-mode')
    
    if (isWidget) {
      // Set data attribute và class chỉ khi ở trang chủ
      document.body.setAttribute('data-widget-mode', 'true')
      document.body.classList.add('widget-mode')
      console.log('Widget mode activated on homepage')
    }

    // Cleanup function
    return () => {
      document.body.removeAttribute('data-widget-mode')
      document.body.classList.remove('widget-mode')
    }
  }, [isWidget, pathname])

  return null
} 